/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {
  calculateTimeDifferenceForChatMessage,
  DateWithTimeFormatter,
} from '../../../../utils/DateUtils'
import {
  getConfigurationByName,
  getDashboardActivityWithPagination,
  updateConfigurationByConfigID,
} from '../../../../API/api-endpoint'
import CustomPagination from '../../../../_metronic/partials/componants/Pagination'
import {Link} from 'react-router-dom'
import {getRouteForProfile} from '../../../../utils/Utils'

const tabs = [
  'all',
  'visit',
  'view',
  'call',
  'location',
  'share',
  'follow',
  'like',
  'comment',
  'chat',
  'report',
  'block',
  'unblock',
  'create_store',
  'edit_store',
  'delete_store',
  'create_offer',
  'edit_offer',
  'end_offer',
  'delete_offer',
  'purchase',
]

const excludedTabs = [
  'all',
  'unblock',
  'create_store',
  'edit_store',
  'delete_store',
  'create_offer',
  'edit_offer',
  'end_offer',
  'delete_offer',
]

const ActivityTable = (props: any) => {
  let {isWebSocketEnabled, setIsWebSocketEnabled, webSocketActivity} = props

  const [tabValue, setTabValue] = useState(isWebSocketEnabled ? 'all' : 'visit')
  const [pageSize, setPageSize] = useState(10)
  const [page, setPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [activityList, setActivityList] = useState(isWebSocketEnabled ? webSocketActivity : [])
  const [configID, setConfigId] = useState(0)
  const [generalSetting, setGeneralSetting] = useState({})

  const renderMessageContent = (messageType: any, activity: any) => {
    switch (messageType) {
      case 'text':
        return (
          <div>
            <Link to={getRouteForProfile(activity?.id1, false)}>
              <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
            </Link>
            <span>sent a message to</span>
            <Link to={getRouteForProfile(activity?.id2, false)}>
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
            </Link>
            <div
              style={{
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                maxWidth: '100%',
                display: 'block',
              }}
            >
              {activity?.message}
            </div>
          </div>
        )
      case 'image':
        return (
          <div>
            <Link to={getRouteForProfile(activity?.id1, false)}>
              <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
            </Link>
            <span>sent a media to</span>
            <Link to={getRouteForProfile(activity?.id2, false)}>
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
            </Link>
          </div>
        )

      default:
        return null
    }
  }

  const renderDisplayMessage = (type: any, activity: any, index: any) => {
    switch (type) {
      case 'chat':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                chat
              </span>
            </td>

            <td>{renderMessageContent(activity.type, activity)}</td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'comment':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                comment
              </span>
            </td>
            <td>
              <div>
                <Link to={getRouteForProfile(activity?.id1, false)}>
                  <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
                </Link>
                <span>commented on</span>
                {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
                {/* </Link> */}
                <span>{' ' + '#' + activity?.id2}</span>
              </div>
              <div
                style={{
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                  maxWidth: '100%',
                  display: 'block',
                }}
              >
                {activity?.comment}
              </div>
            </td>

            <td className='pe-0 text-end min-w-100px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'like':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                like
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>liked</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'call':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                call
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>called</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'location':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                location
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>clicked location</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'share':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                share
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>share this offer</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'follow':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                follow
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>follows</span>
              <Link to={getRouteForProfile(activity?.id2, false)}>
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              </Link>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'visit':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                visit
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>visited </span>
              <Link to={getRouteForProfile(activity?.id2, false)}>
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              </Link>{' '}
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'report':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge badge-secondary me-2'>
                {activity?.userDetail?.registerFrom == 'anonymous' ? 'A' : ''}
              </span>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                offer-report
              </span>
            </td>

            <td>
              <div>
                <Link to={getRouteForProfile(activity?.id1, false)}>
                  <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
                </Link>
                <span> reported</span>
                {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
                {/* </Link> */}
                <span>{' ' + '#' + activity?.id2}</span>
              </div>
              <div>{activity?.reason}</div>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'block':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                block
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>blocked </span>
              <Link to={getRouteForProfile(activity?.id2, false)}>
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              </Link>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.createdAt)}
            </td>
          </tr>
        )
      case 'unblock':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                unblock
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>unblocked </span>
              <Link to={getRouteForProfile(activity?.id2, false)}>
                <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              </Link>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.createdAt)}
            </td>
          </tr>
        )
      case 'view':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#eaeef1', color: '#7b8897'}}>
                view
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>viewed </span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'create_store':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#FFEEF3', color: '#F8285A'}}>
                create-store
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, true)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span> created a store: </span>
              <Link to={getRouteForProfile(activity?.id2, true)}>
                <span style={{color: '#2F78EE'}}>{activity?.name2 + ' '}</span>
              </Link>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'edit_store':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#FFEEF3', color: '#F8285A'}}>
                edit-store
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, true)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span> edited their store details</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'delete_store':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#FFEEF3', color: '#F8285A'}}>
                delete-store
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, true)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span> deleted their store for</span> <span>{activity.reason}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'create_offer':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#DFFFEA', color: '#17C653'}}>
                create-offer
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>created</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'edit_offer':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#ddf5ff', color: '#87ceeb'}}>
                edit-offer
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>edited</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'end_offer':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#ffd6d2', color: '#ff4330'}}>
                end-offer
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>ended</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'delete_offer':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#FFEEF3', color: '#F8285A'}}>
                delete-offer
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>delete</span>
              {/* <Link to={getRouteForProfile(activity?.id2, false)}> */}
              <span style={{color: '#2F78EE'}}>{' ' + activity?.name2}</span>
              {/* </Link> */}
              <span>{' ' + '#' + activity?.id2}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )
      case 'purchase':
        return (
          <tr key={index}>
            <td className='d-flex'>
              <span className='badge' style={{backgroundColor: '#FFEEF3', color: '#F8285A'}}>
                purchase
              </span>
            </td>

            <td>
              <Link to={getRouteForProfile(activity?.id1, false)}>
                <span style={{color: '#2F78EE'}}>{activity?.name1 + ' '}</span>
              </Link>
              <span>{activity?.description}</span>
            </td>

            <td className='pe-0 text-end min-w-50px'>
              {calculateTimeDifferenceForChatMessage(activity?.created_at)}
            </td>
          </tr>
        )

      default:
        return null
    }
  }

  const handleChange = (tabName: any) => {
    setTabValue(tabName)
  }

  useEffect(() => {
    if (!isWebSocketEnabled) {
      if (tabValue === 'all') {
        getActivitiesList(page, pageSize, 'all')
      } else {
        getActivitiesList(page, pageSize, tabValue)
      }
    } else {
      setActivityList(webSocketActivity)
    }
  }, [tabValue, isWebSocketEnabled])

  useEffect(() => {
    getGeneralConfig()
  }, [])

  useEffect(() => {
    if (tabValue === 'all') {
      setActivityList(webSocketActivity)
    } else {
      const filteredActivity = webSocketActivity.filter(
        (activity) => activity.activity_type === tabValue
      )
      setActivityList(filteredActivity)
    }
  }, [webSocketActivity, tabValue])

  const getActivitiesList = async (page: number, pageSize: number, type: any) => {
    let result = await getDashboardActivityWithPagination(page, pageSize, type)
    if (result.success) {
      result = result.data

      setActivityList(result.data)
      setTotalPage(result?.totalPage)
    }
  }

  const getPagination = (page: any, pageSize: any) => {
    if (page === 0 || page === 1) {
      page = 1
    }
    setPage(page)
    let type = tabValue === 'all' ? '' : tabValue
    getActivitiesList(page, pageSize, type)
  }

  const getGeneralConfig = async () => {
    let result = await getConfigurationByName('general_setting')
    if (result.success) {
      //   let parsedData = JSON.parse(result.data.values)
      let parsedData = result.data.values
      setConfigId(result.data._id)
      setIsWebSocketEnabled(parsedData.isWebSocketEnabled)
      setGeneralSetting({
        isWebSocketEnabled: parsedData.isWebSocketEnabled,
        isInAppPurchaseEnabled: parsedData?.isInAppPurchaseEnabled,
        isManualPurchaseEnabled: parsedData?.isManualPurchaseEnabled,
        isProfileImageRequired: parsedData?.isProfileImageRequired,
        isWhatsappEnabled: parsedData?.isWhatsappEnabled,
        whatsappNumber: parsedData?.whatsappNumber,
        isInvoiceEnabled: parsedData?.isInvoiceEnabled,
        isApplePayEnabled: parsedData?.isApplePayEnabled,
      })
    }
  }

  const handleChangeWebSocket = (event: any) => {
    setIsWebSocketEnabled(event.target.checked)
    let updatedConfig = {
      ...generalSetting,
      isWebSocketEnabled: event.target.checked,
    }
    setTabValue(event.target.checked ? 'all' : 'visit')
    setGeneralSetting(updatedConfig)
    updateConfiguration(updatedConfig)
  }

  const updateConfiguration = async (config: any) => {
    let result = await updateConfigurationByConfigID(configID, config, null)
    if (result.success) {
      getGeneralConfig()
    }
  }

  const handleTabClick = (tab) => {
    setTabValue(tab)
    handleChange(tab)
  }

  return (
    <div className={`card`}>
      <div className='card-header border-1'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Recent Activity</span>
        </h3>
        <div>
          <div className='card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <label className='form-check-label' htmlFor='flexSwitchCheckDefault'>
                Websocket On
              </label>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isWebSocketEnabled'
                checked={isWebSocketEnabled}
                onChange={(event) => handleChangeWebSocket(event)}
              />
            </div>
          </div>
        </div>
      </div>

      <div className='card-toolbar mt-2 ps-2'>
        <ul className='nav'>
          {tabs
            .filter((tab) => !(!isWebSocketEnabled && excludedTabs.includes(tab)))
            .map((tab, index) => (
              <li className='nav-item' key={tab}>
                <a
                  className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 ${
                    tabValue === tab ? 'active' : ''
                  } ${index === tabs.length - 1 ? 'me-1' : ''}`}
                  data-bs-toggle='tab'
                  onClick={() => handleTabClick(tab)}
                >
                  {tab.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())}
                </a>
              </li>
            ))}
        </ul>
      </div>

      <div className='card-body py-3' style={{height: '450px', overflowY: 'scroll'}}>
        <div className='tab-content'>
          {/* begin::Tap pane */}
          <div className='tab-pane fade show active'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='border-0'>
                    <th className='p-0 w-50px'></th>
                    <th className='p-0 min-w-280px'></th>
                    <th className='p-0 min-w-20px'></th>
                    <th className='p-0 min-w-20px'></th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {activityList !== undefined &&
                    activityList.map((activity: any, index: number) => {
                      return renderDisplayMessage(
                        isWebSocketEnabled ? activity.activity_type : tabValue,
                        activity,
                        index
                      )
                    })}
                </tbody>
                {/* end::Table body */}
              </table>
            </div>
            {/* end::Table */}
          </div>
          {/* end::Tap pane */}
        </div>
      </div>

      <div className='card-footer'>
        {activityList.length !== 0 && (
          <CustomPagination
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalPage={totalPage}
            cb={getPagination}
          />
        )}
      </div>
    </div>
  )
}

export {ActivityTable}
